import script from "./LayoutItem.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutItem.vue?vue&type=script&setup=true&lang=js"

import "./LayoutItem.vue?vue&type=style&index=0&id=67aa4df3&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67aa4df3"]])

export default __exports__